const dashboards = {
  title: 'Dashboards',
  addDashboard: 'Adicionar Dashboard',
  addFirstDashboard: 'Adicionar Primeira Dashboard',
  removeDashboard: 'Remover Dashboard',
  editDashboard: 'Editar Dashboard',
  pinDashboard: 'Fixar Dashboard',
  unpinDashboard: 'Remover',
  exportCSV: 'Exportar CSV',
  settings: 'Configurações',
  settingsDescription: 'Configure o tamanho e filtros do dashboard',
  refresh: 'Atualizar',
  size: 'Tamanho',
  filters: 'Filtros',
  dateRangeNotImplemented: 'Intervalo de datas (em breve)',

  // Labels de coluna de tabelas de dashboard. Resolvidos por `field` quando o
  // template grava o label como string só-inglês (legado). Templates com label
  // {en,pt} têm precedência e não passam por aqui.
  columns: {
    full_name: 'Usuário',
    email: 'Email',
    event_count: 'Eventos',
    rating: 'Avaliação',
    comment: 'Comentário',
    submitted_at: 'Data',
    first_seen_at: 'Data',
    title: 'Título',
    scheduled: 'Agendadas',
    joined_count: 'Participaram',
    transcribed: 'Transcritas',
    errored: 'Erros',
    top_model: 'Modelo Top',
    models_count: 'Modelos',
    total_tokens: 'Tokens',
    total_calls: 'Chamadas',
    total_cost_usd: 'Custo (USD)',
  },

  sizes: {
    small: 'Pequeno',
    medium: 'Médio',
    large: 'Grande',
    full: 'Total',
  },
  noDashboards: 'Nenhuma dashboard configurada',
  noDashboardsDescription: 'Adicione dashboards para visualizar suas métricas e análises',
  noDashboardsAvailable: 'Nenhuma dashboard disponível',
  loadingDashboards: 'Carregando dashboards...',
  errorLoading: 'Erro ao carregar dados',
  noData: 'Sem dados disponíveis',
  retry: 'Tentar novamente',
  confirmRemove: 'Tem certeza que deseja remover esta dashboard?',
  addSuccess: 'Dashboard adicionada com sucesso',
  addError: 'Erro ao adicionar dashboard',
  removeSuccess: 'Dashboard removida com sucesso',
  removeError: 'Erro ao remover dashboard',
  unsupportedChartType: 'Tipo de gráfico não suportado',
  
  addDashboardDescription: 'Escolha dashboards disponíveis para adicionar à sua visualização',
  searchDashboards: 'Buscar dashboards...',
  allCategories: 'Todas',
  add: 'Adicionar',
  
  categories: {
    metrics: 'Ferramentas',
    analytics: 'Análises',
    reports: 'Relatórios',
  },
  
  chartTypes: {
    line: 'Linha',
    bar: 'Barras',
    pie: 'Pizza',
    donut: 'Rosca',
    gauge: 'Medidor',
    area: 'Área',
    scatter: 'Dispersão',
  },

  dateRange: {
    selectPeriod: 'Selecione o período',
    last7Days: 'Últimos 7 dias',
    last14Days: 'Últimos 14 dias',
    last30Days: 'Últimos 30 dias',
    last60Days: 'Últimos 60 dias',
    last90Days: 'Últimos 90 dias',
    last6Months: 'Últimos 6 meses',
    lastYear: 'Último ano',
    custom: 'Período personalizado',
    startDate: 'Data inicial',
    endDate: 'Data final',
    selectDate: 'Selecionar data',
  },
  export: {
    success: "Sucesso!",
    successDescription: "Dados exportados com sucesso.",
    error: "Erro",
    errorDescription: "Erro ao exportar dados. Tente novamente.",
  },

  formFactor: {
    tile: 'Tile',
    graph: 'Gráfico',
    table: 'Tabela',
    hero: 'Destaque',
  },

  layouts: {
    freeGrid: 'Sem layout',
    myLayouts: 'Meus layouts',
    suggested: 'Sugeridos',
    create: 'Novo layout',
    createDescription: 'Dê um nome ao seu novo layout. Você poderá montar a estrutura dele em seguida.',
    namePlaceholder: 'Nome do layout',
    rename: 'Renomear',
    renameTitle: 'Renomear layout',
    duplicate: 'Duplicar',
    delete: 'Excluir',
    deleteTitle: 'Excluir layout?',
    deleteDescription: 'Esta ação não pode ser desfeita. As atribuições de dashboards a este layout serão perdidas.',
    addSlot: 'Adicionar slot',
    removeSlot: 'Remover slot',
    addToSlot: 'Adicionar dashboard',
    unassignSlot: 'Remover do slot',
    suggestedReadOnly: 'Layout sugerido não pode ser editado. Duplique para personalizar.',
    saveError: 'Erro ao salvar layout',
    unassignedBanner_one: '{{count}} dashboard não cabe neste layout e está oculto.',
    unassignedBanner_other: '{{count}} dashboards não cabem neste layout e estão ocultos.',
    useFreeGrid: 'Ver todos',
    switcherAria: 'Trocar layout (atual: {{name}})',
    emptySlotAria: 'Slot vazio do tipo {{type}}',
    copySuffix: '(cópia)',
  },

  // PBI #78540 — Cascading dashboard preferences (3-layer inheritance) UX.
  defaults: {
    menuTitle: 'Salvar como Padrão',
    forOrganization: 'Organização',
    forWorkspace: 'Workspace',
    forSuperadmin: 'Superadmin',
    forAllOrgs: 'Todas as Organizações',
    forAllWorkspaces: 'Todos os Workspaces',
    confirmTitle: 'Confirmar',
    confirmOrg: 'Salvar este layout como padrão da organização? Usuários sem layout próprio passarão a vê-lo.',
    confirmWorkspace: 'Salvar este layout como padrão do workspace? Usuários sem layout próprio neste workspace passarão a vê-lo.',
    confirmSuperadmin: 'Salvar este layout como padrão da tela Superadmin? Todos os superadmins sem layout próprio passarão a vê-lo.',
    confirmAllOrgs: 'Salvar este layout como padrão global para TODAS as organizações? Orgs sem layout próprio e usuários sem customização passarão a vê-lo.',
    confirmAllWorkspaces: 'Salvar este layout como padrão global para TODOS os workspaces? Workspaces sem layout próprio e usuários sem customização passarão a vê-lo.',
    savedOrg: 'Layout salvo como padrão da organização.',
    savedWorkspace: 'Layout salvo como padrão do workspace.',
    savedPlatform: 'Layout salvo como padrão global.',
    saveError: 'Falha ao salvar como padrão.',
    resetPreferences: 'Limpar Preferências',
    resetTitle: 'Limpar preferências?',
    resetSuperadminMsg: 'Suas preferências de superadmin serão apagadas. Você passará a ver o layout default global da plataforma. Esta ação não pode ser desfeita.',
    resetOrgMsg: 'Suas preferências desta organização serão apagadas. Você passará a ver o layout default da organização (ou o global, se não houver). Esta ação não pode ser desfeita.',
    resetWorkspaceMsg: 'Suas preferências deste workspace serão apagadas. Você passará a ver o layout default do workspace (ou o global). Esta ação não pode ser desfeita.',
    resetConfirm: 'Limpar',
    resetSuccess: 'Preferências limpas.',
    resetError: 'Falha ao limpar preferências.',
  },

  tabs: {
    addTab: 'Adicionar aba',
    add: 'Adicionar aba',
    rename: 'Renomear',
    renameTitle: 'Renomear aba',
    duplicate: 'Duplicar',
    delete: 'Excluir',
    deleteTitle: 'Excluir aba?',
    deleteDescription: 'Esta ação não pode ser desfeita. Os dashboards e layouts desta aba serão perdidos.',
    options: 'Opções da aba',
    namePlaceholder: 'Nome da aba',
    defaultName: 'Principal',
  },

  // Templates admin page (Settings > Templates > Dashboards).
  templatesAdmin: {
    searchPlaceholder: 'Buscar por nome, scope, tipo ou categoria...',
    newTemplate: 'Novo template',
    columnName: 'Nome',
    columnScope: 'Scope',
    columnType: 'Tipo',
    columnCategory: 'Categoria',
    columnActive: 'Ativo',
    columnActions: 'Ações',
    emptySearch: 'Nenhum template encontrado para essa busca.',
    emptyInitial: 'Nenhum template ainda. Clique em "Novo template" para começar.',
    actionPublish: 'Publicar para todas as instâncias',
    actionEdit: 'Editar',
    actionDeactivate: 'Desativar',
    deactivateTitle: 'Desativar template?',
    deactivateDescription: 'O template será desativado (não será mais distribuído para novas organizações/produtos). Instâncias existentes em dashboards_base permanecem inalteradas.',
    deactivateConfirm: 'Desativar',
    publishTitle: 'Publicar template?',
    publishDescriptionOrgs: 'O template <strong>{{name}}</strong> será instalado em todas as organizações ativas onde ainda não exista uma instância. Esta operação é idempotente — instâncias já criadas não serão sobrescritas.',
    publishDescriptionProducts: 'O template <strong>{{name}}</strong> será instalado em todos os produtos ativos onde ainda não exista uma instância. Esta operação é idempotente — instâncias já criadas não serão sobrescritas.',
    publishConfirm: 'Publicar',
    publishing: 'Publicando...',
    cancel: 'Cancelar',
    toastDeactivated: 'Template desativado',
    toastSuperadminNoInstances: 'Templates superadmin não geram instâncias.',
    toastPublishSummary: 'Publicado: {{installed}} novos / {{skipped}} já existiam / {{failed}} falharam (em {{targets}} {{scopeLabel}}).',
    scopeLabelOrgs: 'orgs',
    scopeLabelProducts: 'produtos',
  },
};

export default dashboards;
